<template>
    <div class="container">
        <span @click="$emit('close')" role="button"><small><i class="fa-solid fa-chevron-left me-2"></i>{{ $t('common.back') }}</small></span>
        <h2 class="my-3">{{ title || $t('modal.pickTextTemplate') }}</h2>

        <div class="card shadow border-0">
            <ul class="list-group list-group-flush">
                <li v-for="textTemplate in templates" :key="textTemplate.id" class="list-group-item p-0">
                    <button type="button" class="btn btn-link text-start text-decoration-none text-body w-100 p-3"
                        @click="$emit('template-picked', textTemplate)">
                        <div class="fw-medium text-break">{{ textTemplate.name }}</div>
                        <div class="text-muted small text-break template-description">{{ textTemplate.description }}</div>
                    </button>
                </li>
            </ul>
        </div>

        <div class="row mt-3">
            <div class="col">
                <button @click="$emit('close')" class="btn border-1 border-primary text-primary w-100">{{ $t('common.cancel') }}</button>
            </div>
        </div>
    </div>
</template>


<script>
export default {
    props: {
        templates: {
            type: Array,
            required: true
        },
        // Left empty the picker keeps its original description-template heading,
        // so the notes2 caller needs no change.
        title: {
            type: String,
            default: ''
        }
    },
    emits: ['close', 'template-picked']
};
</script>


<style scoped>
/* Keep the body readable without letting one long template fill the screen —
   the full text lands in the textarea anyway. */
.template-description {
    white-space: pre-wrap;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
}
</style>
